(function () {
  'use strict';

  var IS_MOBILE = window.matchMedia('(max-width: 749px)').matches;
  window.matchMedia('(max-width: 749px)').addEventListener('change', function (e) {
    IS_MOBILE = e.matches;
    if (deckWrapGlobal) resizeMobileDeck(deckWrapGlobal, deckGlobal, rootGlobal);
  });

  var deckWrapGlobal = null;
  var deckGlobal = null;
  var rootGlobal = null;

  function resizeMobileDeck(deckWrap, deck, root) {
    if (!IS_MOBILE) {
      deckWrap.style.width = '';
      deckWrap.style.height = '';
      deck.style.width = '';
      deck.style.height = '';
      return;
    }
    var cs = getComputedStyle(root);
    var cardWM = parseFloat(cs.getPropertyValue('--pyv-card-w-m')) || 340;
    var cardHM = parseFloat(cs.getPropertyValue('--pyv-card-h-m')) || 720;
    var offsetX = parseFloat(cs.getPropertyValue('--pyv-stack-offset-x')) || 12;
    var offsetY = parseFloat(cs.getPropertyValue('--pyv-stack-offset-y')) || 10;
    var containerEl = root.querySelector('.pyv-container') || root;
    var containerW = containerEl.offsetWidth - 32;
    var totalWrapW = cardWM + offsetX * 2;
    var scale = Math.min(1, containerW / totalWrapW);
    var scaledCardW = Math.floor(cardWM * scale);
    var scaledCardH = Math.floor(cardHM * scale);
    var scaledWrapW = Math.floor(totalWrapW * scale);
    var scaledWrapH = Math.floor((cardHM + offsetY * 2) * scale);
    deckWrap.style.width = scaledWrapW + 'px';
    deckWrap.style.height = scaledWrapH + 'px';
    deck.style.width = scaledCardW + 'px';
    deck.style.height = scaledCardH + 'px';
    root.style.setProperty('--pyv-stack-offset-x-actual', Math.floor(offsetX * scale) + 'px');
    root.style.setProperty('--pyv-stack-offset-y-actual', Math.floor(offsetY * scale) + 'px');
  }

  function ready() {
    if (!window.PYVCard) { return setTimeout(ready, 30); }
    document.querySelectorAll('[data-pyv-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  function initSection(root) {
    var PYVCard = window.PYVCard;
    var escHtml = PYVCard.escHtml;
    var getSelectedVariant = PYVCard.getSelectedVariant;
    /* Use the single shared buildStarsHTML from PYVCard — exact star design lives there */
    var buildStarsHTML = PYVCard.buildStarsHTML;

    var dataEl = root.querySelector('[data-pyv-data]');
    if (!dataEl) return;

    var products = [];
    try { products = JSON.parse(dataEl.textContent || '[]'); } catch (e) {
      console.error('PYV: failed to parse product data', e); return;
    }
    if (!products.length) return;

    products.forEach(function (p) {
      var fi = p.variants ? p.variants.findIndex(function (v) { return v.available; }) : -1;
      p.selectedVariantIdx = fi >= 0 ? fi : 0;
    });

    var swipeThreshold = parseFloat(root.dataset.swipeThreshold) || 25;
    var arrowsAsActions = root.dataset.arrowsAsActions === 'true';
    var upNextCount = parseInt(root.dataset.upNextCount, 10) || 4;
    var autoOpenCart = root.dataset.autoOpenCart !== 'false';

    /* ---- View product settings ---- */
    var showViewProduct = root.dataset.showViewProduct !== 'false';
    var viewProductText = root.dataset.viewProductText || 'View product';
    var viewProductNewTab = root.dataset.viewProductNewTab !== 'false';

    function getOffsets() {
      var cs = getComputedStyle(root);
      var ox = parseFloat(cs.getPropertyValue('--pyv-stack-offset-x')) || 12;
      var oy = parseFloat(cs.getPropertyValue('--pyv-stack-offset-y')) || 10;
      if (IS_MOBILE) {
        var ax = parseFloat(cs.getPropertyValue('--pyv-stack-offset-x-actual'));
        var ay = parseFloat(cs.getPropertyValue('--pyv-stack-offset-y-actual'));
        if (!isNaN(ax)) ox = ax;
        if (!isNaN(ay)) oy = ay;
      }
      return { x: ox, y: oy };
    }

    var mobileInfoOpts = {
      sizeLabel: root.dataset.sizeLabel || 'Size',
      sizeGuideText: root.dataset.sizeGuideText || 'Size Guide',
      sizeGuideUrl: root.dataset.sizeGuideUrl || '',
      showViewProduct: showViewProduct,
      viewProductText: viewProductText,
      viewProductNewTab: viewProductNewTab
    };

    var sizeGuidePageUrl = (root.dataset.sizeGuidePage || '').trim();
    var sizeGuideEffectiveUrl = sizeGuidePageUrl || mobileInfoOpts.sizeGuideUrl;
    mobileInfoOpts.sizeGuideUrl = sizeGuideEffectiveUrl;

    var state = {
      products: products,
      queue: products.map(function (_, i) { return i; }),
      animating: false,
      statusLocked: false
    };

    var statusFadeTimer = null;

    /* ---- DOM refs ---- */
    var deckWrap = root.querySelector('[data-pyv-deck-wrap]');
    var deck = root.querySelector('[data-pyv-deck]');
    var emptyEl = root.querySelector('[data-pyv-empty]');
    var statusEl = root.querySelector('[data-pyv-status]');
    var upNextEl = root.querySelector('[data-pyv-upnext]');
    var upNextList = root.querySelector('[data-pyv-upnext-list]');
    var upNextSizerList = root.querySelector('[data-pyv-upnext-sizer-list]');
    var paginationEl = root.querySelector('[data-pyv-pagination]');
    var cartCountEl = root.querySelector('[data-pyv-cart-count]');
    var cartBadgeEl = root.querySelector('[data-pyv-cart-badge]');
    var instrAddEl = root.querySelector('[data-pyv-instr-add]');
    var instrPassEl = root.querySelector('[data-pyv-instr-pass]');
    var cvNameEl = root.querySelector('[data-pyv-cv-name]');
    var cvPriceEl = root.querySelector('[data-pyv-cv-price]');
    var cvSizesEl = root.querySelector('[data-pyv-cv-sizes]');
    var cvStarsEl = root.querySelector('[data-pyv-cv-stars]');
    var cvRatingMetaEl = root.querySelector('[data-pyv-cv-rating-meta]');
    var wishlistBtn = root.querySelector('[data-pyv-wishlist]');
    var viewProductEl = root.querySelector('[data-pyv-view-product]');
    var actionLabelEl = root.querySelector('[data-pyv-action-label]');
    var actionNameEl = root.querySelector('[data-pyv-action-name]');
    var actionSizeEl = root.querySelector('[data-pyv-action-size]');
    var actionPriceEl = root.querySelector('[data-pyv-action-price]');
    var actionMsgEl = root.querySelector('[data-pyv-action-msg]');
    var passBtn = root.querySelector('[data-pyv-action="pass"]');
    var addBtn = root.querySelector('[data-pyv-action="add"]');
    var prevBtn = root.querySelector('[data-pyv-prev]');
    var nextBtn = root.querySelector('[data-pyv-next]');
    var cvSizerEl = root.querySelector('[data-pyv-cv-sizer]');
    var cvSizerSizesEl = root.querySelector('[data-pyv-cv-sizer-sizes]');

    deckWrapGlobal = deckWrap;
    deckGlobal = deck;
    rootGlobal = root;

    resizeMobileDeck(deckWrap, deck, root);

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        resizeMobileDeck(deckWrap, deck, root);
        render();
      }, 120);
    });

    /* ---- Size Guide Modal ---- */
    var sgModal = root.querySelector('[data-pyv-sg-modal]');
    var sgLoadingEl = sgModal ? sgModal.querySelector('[data-pyv-sg-loading]') : null;
    var sgContentEl = sgModal ? sgModal.querySelector('[data-pyv-sg-content]') : null;
    var sgCloseEls = sgModal ? sgModal.querySelectorAll('[data-pyv-sg-close]') : [];
    var sgCache = {};

    function openSizeGuide(url) {
      if (!sgModal || !url) return;
      sgModal.hidden = false;
      document.body.style.overflow = 'hidden';
      if (sgLoadingEl) sgLoadingEl.hidden = false;
      if (sgContentEl) { sgContentEl.hidden = true; sgContentEl.innerHTML = ''; }
      if (sgCache[url]) { renderSizeGuideContent(sgCache[url]); return; }
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          /* FIX: drop theme chrome FIRST, so the whole main region can be
             used as content. OS 2.0 header/footer groups render with ids
             like shopify-section-sections--…; vintage themes use ids like
             shopify-section-header. The page template's own sections
             (shopify-section-template--…) are kept — this matters because
             the size guide page is a two-file architecture: table markup +
             CSS-only unit toggle (<style>) in the page description, and the
             JS companion in a Custom Liquid block/section (Shopify's page
             editor strips <script> from page content, so it lives there). */
          doc.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
            var secIdRaw = (el.id || '').toLowerCase();
            var isChrome = secIdRaw.indexOf('sections--') !== -1 ||
              /header|footer|announcement/.test(secIdRaw);
            if (isChrome && el.parentNode) el.parentNode.removeChild(el);
          });
          ['header', 'footer', 'nav', 'noscript'].forEach(function (tag) {
            doc.querySelectorAll(tag).forEach(function (el) {
              if (el.parentNode) el.parentNode.removeChild(el);
            });
          });

          /* Prefer the whole main region: with chrome already removed it
             contains ALL of the page template's sections — including the
             Custom Liquid section carrying the JS companion, which the old
             main-page-only selectors left behind. */
          var content =
            doc.querySelector('main, #MainContent, #main-content, [role="main"]');
          if (!content) {
            content =
              doc.querySelector('.shopify-section--main-page') ||
              doc.querySelector('[id*="shopify-section"][id*="main-page"]') ||
              doc.querySelector('[id*="shopify-section"][id*="main_page"]');
          }
          if (!content) {
            content =
              doc.querySelector('.page__content') ||
              doc.querySelector('.page-content') ||
              doc.querySelector('[data-section-type="page"]') ||
              doc.querySelector('.shopify-section-page') ||
              doc.querySelector('.rte') ||
              doc.querySelector('#MainContent .page-width') ||
              doc.querySelector('[role="main"] .page-width') ||
              doc.querySelector('main .page-width');
          }
          if (!content || content === doc.body) {
            var excludeIds = ['header', 'footer', 'navigation', 'nav', 'announcement'];
            var sections = Array.prototype.slice.call(doc.querySelectorAll('.shopify-section'));
            for (var si = 0; si < sections.length; si++) {
              var sec = sections[si];
              var secId = (sec.id || '').toLowerCase();
              var isExcluded = excludeIds.some(function (ex) { return secId.indexOf(ex) !== -1; });
              if (isExcluded) continue;
              var txt = (sec.textContent || '').trim();
              if (txt.length > 20) { content = sec; break; }
            }
          }

          /* FIX: lift executable scripts out BEFORE reading innerHTML —
             <script> tags inserted via innerHTML are inert by spec, so they
             must be re-created as real elements after injection. Only
             scripts inside the extracted content are taken (the unit-toggle
             companion), never the theme's global scripts. JSON blobs
             (type="application/json" etc.) are left in place untouched. */
          var scripts = [];
          if (content) {
            content.querySelectorAll('script').forEach(function (s) {
              var type = (s.getAttribute('type') || '').toLowerCase();
              if (type && type !== 'text/javascript' && type !== 'module') return;
              scripts.push({
                src:  s.getAttribute('src') || '',
                text: s.textContent || '',
                type: type
              });
              if (s.parentNode) s.parentNode.removeChild(s);
            });
          }

          var entry = {
            html: content ? content.innerHTML : '<p>Content unavailable.</p>',
            scripts: scripts
          };
          sgCache[url] = entry;
          renderSizeGuideContent(entry);
        })
        .catch(function (err) {
          console.error('PYV: size guide fetch failed', err);
          if (sgLoadingEl) sgLoadingEl.hidden = true;
          if (sgContentEl) {
            sgContentEl.hidden = false;
            sgContentEl.innerHTML = '<p style="color:#888;text-align:center;padding:24px;">Could not load size guide. <a href="' + escHtml(url) + '" target="_blank" rel="noopener">Open in new tab</a></p>';
          }
        });
    }

    function renderSizeGuideContent(entry) {
      if (sgLoadingEl) sgLoadingEl.hidden = true;
      if (!sgContentEl) return;
      sgContentEl.hidden = false;
      sgContentEl.innerHTML = entry.html;
      /* FIX: <style> and <link> tags are KEPT — the page's inline <style>
         is what powers the IN/CM unit toggle; stripping it made both unit
         spans render concatenated and unstyled. Only iframes are dropped. */
      sgContentEl.querySelectorAll('iframe').forEach(function (el) { el.remove(); });
      /* Re-create the JS companion so it executes against the freshly
         injected DOM — runs on every open since innerHTML wipes the
         previous listeners. */
      (entry.scripts || []).forEach(function (s) {
        var tag = document.createElement('script');
        if (s.type) tag.type = s.type;
        if (s.src) { tag.src = s.src; } else { tag.textContent = s.text; }
        sgContentEl.appendChild(tag);
      });
    }

    function closeSizeGuide() {
      if (!sgModal) return;
      sgModal.hidden = true;
      document.body.style.overflow = '';
    }

    sgCloseEls.forEach(function (el) { el.addEventListener('click', closeSizeGuide); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sgModal && !sgModal.hidden) closeSizeGuide();
    });
    root.querySelectorAll('[data-pyv-sg-trigger]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); openSizeGuide(sizeGuideEffectiveUrl); });
    });

    /* ---- Helpers ---- */
    function getCurrent() { return state.products[state.queue[0]]; }

    function getUpNextFromOffset(offset) {
      var items = [];
      var len = state.queue.length;
      for (var i = offset; items.length < upNextCount; i++) {
        items.push(state.products[state.queue[i % len]]);
        if (i - offset >= len - 1) break;
      }
      return items;
    }

    function getUpNextProducts() { return getUpNextFromOffset(1); }

    /* ---- Ratings — read from pre-serialised JSON ---- */
    function getProductRating(product) {
      var score = product.rating != null ? parseFloat(product.rating) : NaN;
      var count = product.review_count != null ? parseInt(product.review_count, 10) : NaN;
      if (isNaN(score)) return null;
      return { score: score, count: isNaN(count) ? null : count };
    }

    function updateDesktopRatings(product) {
      if (!cvStarsEl) return;
      var data = getProductRating(product);
      if (data && data.score != null) {
        cvStarsEl.innerHTML = buildStarsHTML(data.score);
        if (cvRatingMetaEl) {
          var meta = '<span class="pyv-cv-rating-score">' + escHtml(parseFloat(data.score).toFixed(1)) + '</span>';
          if (data.count != null) meta += '<span class="pyv-cv-rating-count">(' + escHtml(String(data.count)) + ' reviews)</span>';
          cvRatingMetaEl.innerHTML = meta;
        }
        syncSizerRatings(data);
      } else {
        cvStarsEl.innerHTML = '';
        if (cvRatingMetaEl) cvRatingMetaEl.innerHTML = '';
        syncSizerRatings(null);
      }
    }

    /* ---- CV sizer sync ---- */
    function syncSizer(product) {
      if (!cvSizerEl) return;
      var sv = PYVCard.getSelectedVariant(product);
      var sizerName = cvSizerEl.querySelector('.pyv-cv-name');
      if (sizerName) sizerName.textContent = product.title || '\u00a0';
      var sizerPrice = cvSizerEl.querySelector('.pyv-cv-price');
      if (sizerPrice) sizerPrice.textContent = sv ? sv.price : '\u00a0';
      if (cvSizerSizesEl) {
        cvSizerSizesEl.innerHTML = '';
        var sizes = PYVCard.getUniqueSizeVariants(product);
        sizes.forEach(function (s) {
          var btn = document.createElement('span');
          btn.className = 'pyv-size-pill';
          btn.textContent = s.size;
          cvSizerSizesEl.appendChild(btn);
        });
      }
    }

    function syncSizerRatings(data) {
      if (!cvSizerEl) return;
      var sizerStars = cvSizerEl.querySelector('.pyv-cv-rating-stars');
      var sizerMeta = cvSizerEl.querySelector('.pyv-cv-rating-meta');
      if (sizerStars) sizerStars.innerHTML = data ? buildStarsHTML(data.score) : '\u00a0';
      if (sizerMeta) {
        if (data && data.score != null) {
          var meta = '<span class="pyv-cv-rating-score">' + escHtml(parseFloat(data.score).toFixed(1)) + '</span>';
          if (data.count != null) meta += '<span class="pyv-cv-rating-count">(' + escHtml(String(data.count)) + ' reviews)</span>';
          sizerMeta.innerHTML = meta;
        } else {
          sizerMeta.innerHTML = '\u00a0';
        }
      }
    }

    /* ---- View product link (desktop panel) ---- */
    function updateViewProductLink(product) {
      if (!viewProductEl) return;
      if (product && product.url) {
        viewProductEl.href = product.url;
        viewProductEl.style.display = '';
      } else {
        viewProductEl.removeAttribute('href');
        viewProductEl.style.display = 'none';
      }
    }

    /* ---- Currently Viewing panel ---- */
    function updateCurrentlyViewing(product) {
      if (!statusEl) return;
      statusEl.classList.remove('is-fading-out');
      statusEl.dataset.state = 'viewing';
      if (cvNameEl) cvNameEl.textContent = product.title;
      var sv = getSelectedVariant(product);
      if (cvPriceEl) cvPriceEl.textContent = sv ? sv.price : '';
      updateViewProductLink(product);
      syncSizer(product);
      if (cvSizesEl) {
        PYVCard.renderSizePills(product, cvSizesEl, function (s, prod) {
          if (cvPriceEl) cvPriceEl.textContent = s.price;
          var sizerPrice = cvSizerEl ? cvSizerEl.querySelector('.pyv-cv-price') : null;
          if (sizerPrice) sizerPrice.textContent = s.price;
          var topCard = deck.querySelector('.pyv-card-top');
          if (topCard) {
            var infoEl = topCard.querySelector('.pyv-overlay-info');
            if (infoEl) infoEl.innerHTML = '<span class="pyv-overlay-swatch" aria-hidden="true"></span> ' + escHtml(prod.title) + ' &middot; ' + escHtml(s.size);
          }
          var mobileInfo = deck.querySelector('.pyv-mobile-info');
          if (mobileInfo) { PYVCard.updateMobileInfoBar(mobileInfo, prod, mobileInfoOpts); attachMobileSizeGuide(mobileInfo); }
        });
      }
      updateDesktopRatings(product);
      if (wishlistBtn) {
        var wKey = 'pyv_wl_' + root.id;
        var wl = [];
        try { wl = JSON.parse(localStorage.getItem(wKey) || '[]'); } catch (_) {}
        wishlistBtn.classList.toggle('is-wishlisted', wl.indexOf(product.id) !== -1);
      }
    }

    /* ---- Wishlist ---- */
    if (wishlistBtn) {
      wishlistBtn.addEventListener('click', function () {
        var cur = getCurrent();
        if (!cur) return;
        var wKey = 'pyv_wl_' + root.id;
        var wl = [];
        try { wl = JSON.parse(localStorage.getItem(wKey) || '[]'); } catch (_) {}
        var ei = wl.indexOf(cur.id);
        if (ei >= 0) { wl.splice(ei, 1); wishlistBtn.classList.remove('is-wishlisted'); }
        else { wl.push(cur.id); wishlistBtn.classList.add('is-wishlisted'); }
        try { localStorage.setItem(wKey, JSON.stringify(wl)); } catch (_) {}
      });
    }

    /* ---- Action state ---- */
    function showActionState(stateType, product) {
      if (!statusEl) return;
      statusEl.classList.remove('is-fading-out');
      statusEl.dataset.state = stateType;
      var sv = getSelectedVariant(product);
      if (stateType === 'adding') { if (actionLabelEl) actionLabelEl.textContent = 'ADDING TO CART'; if (actionMsgEl) actionMsgEl.textContent = 'Release to confirm!'; }
      else if (stateType === 'added') { if (actionLabelEl) actionLabelEl.textContent = 'ADDED TO CART'; if (actionMsgEl) actionMsgEl.textContent = ''; }
      else if (stateType === 'passing') { if (actionLabelEl) actionLabelEl.textContent = 'PASSING'; if (actionMsgEl) actionMsgEl.textContent = 'Release to confirm!'; }
      else if (stateType === 'passed') { if (actionLabelEl) actionLabelEl.textContent = 'PASSED'; if (actionMsgEl) actionMsgEl.textContent = ''; }
      if (actionNameEl) actionNameEl.textContent = product.title;
      if (actionSizeEl) actionSizeEl.textContent = sv ? sv.size : '';
      if (actionPriceEl) actionPriceEl.textContent = sv ? sv.price : '';
    }

    /* ---- Up Next — renders both real list and sizer ghost ---- */
    function buildUpNextItemsHTML(items) {
      if (!items.length) {
        return '<li class="pyv-up-next-empty">That\'s all for now</li>';
      }
      return items.map(function (p) {
        var thumb = p.thumbnail || p.image || '';
        var sv = getSelectedVariant(p);
        return '<li class="pyv-up-next-item">' +
          '<a class="pyv-up-next-link" <!--href="' + escHtml(p.url) + '"-->' +
            '<span class="pyv-up-next-thumb" style="background-image: url(\'' + escHtml(thumb) + '\');"></span>' +
            '<span class="pyv-up-next-text">' +
              '<span class="pyv-up-next-name">' + escHtml(p.title) + '</span>' +
              '<span class="pyv-up-next-price">' + escHtml(sv ? sv.price : '') + '</span>' +
            '</span>' +
            // '<span class="pyv-up-next-arrow" aria-hidden="true">&rsaquo;</span>' +
          '</a>' +
        '</li>';
      }).join('');
    }

    function renderUpNextFromList(items) {
      if (!upNextList) return;
      upNextList.innerHTML = buildUpNextItemsHTML(items);
      if (upNextSizerList) upNextSizerList.innerHTML = buildUpNextItemsHTML(items);
    }

    function renderUpNext() { renderUpNextFromList(getUpNextProducts()); }

    /* ---- Pagination ---- */
    function initPagination() {
      if (!paginationEl) return;
      paginationEl.innerHTML = '';
      state.products.forEach(function () {
        var dot = document.createElement('span');
        dot.className = 'pyv-pag-dot';
        dot.setAttribute('role', 'tab');
        paginationEl.appendChild(dot);
      });
    }

    function updatePagination() {
      if (!paginationEl) return;
      var activeIdx = state.queue[0];
      paginationEl.querySelectorAll('.pyv-pag-dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === activeIdx);
      });
    }

    /* ---- Mobile size guide ---- */
    function attachMobileSizeGuide(bar) {
      if (!bar || !sizeGuideEffectiveUrl) return;
      var link = bar.querySelector('.pyv-mobile-size-guide');
      if (!link) return;
      var newLink = link.cloneNode(true);
      link.parentNode.replaceChild(newLink, link);
      newLink.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openSizeGuide(sizeGuideEffectiveUrl); });
    }

    /* ---- Stack positioning ---- */
    function applyStackPosition(card, stackIndex) {
      var offsets = getOffsets();
      var tx = -(stackIndex * offsets.x);
      var ty = stackIndex * offsets.y;
      card.style.transform = 'translate(' + tx + 'px, ' + ty + 'px)';
      card.style.zIndex = String(10 - stackIndex);
      card.style.opacity = '1';
    }

    /* ---- Drag side-state changes ---- */
    function updateSideStates(dx) {
      var current = getCurrent();
      if (!current) return;
      if (dx > 8) {
        if (instrAddEl) instrAddEl.classList.add('is-active');
        if (instrPassEl) instrPassEl.classList.remove('is-active');
        if (!IS_MOBILE) showActionState('adding', current);
        if (upNextEl) upNextEl.dataset.state = 'confirming-add';
        if (addBtn) addBtn.classList.add('is-priming');
        if (passBtn) passBtn.classList.remove('is-priming');
      } else if (dx < -8) {
        if (instrAddEl) instrAddEl.classList.remove('is-active');
        if (instrPassEl) instrPassEl.classList.remove('is-active');
        if (!IS_MOBILE) showActionState('passing', current);
        if (upNextEl) upNextEl.dataset.state = 'confirming-pass';
        if (passBtn) passBtn.classList.add('is-priming');
        if (addBtn) addBtn.classList.remove('is-priming');
      } else {
        resetAllUI();
      }
    }

    function resetAllUI() {
      if (instrAddEl) instrAddEl.classList.remove('is-active');
      if (instrPassEl) instrPassEl.classList.remove('is-active');
      if (upNextEl) upNextEl.dataset.state = 'idle';
      if (addBtn) addBtn.classList.remove('is-priming');
      if (passBtn) passBtn.classList.remove('is-priming');
      if (!state.statusLocked && statusEl && statusEl.dataset.state !== 'viewing') {
        var cur = getCurrent();
        if (cur) updateCurrentlyViewing(cur);
      }
    }

    /* ---- Build opts ---- */
    function getBuildOpts() {
      return {
        isMobile: IS_MOBILE,
        sizeLabel: mobileInfoOpts.sizeLabel,
        sizeGuideText: mobileInfoOpts.sizeGuideText,
        sizeGuideUrl: sizeGuideEffectiveUrl,
        showViewProduct: showViewProduct,
        viewProductText: viewProductText,
        viewProductNewTab: viewProductNewTab
      };
    }

    /* ====================================================
       render()
    ==================================================== */
    function render(isAfterTransition) {
      deck.querySelectorAll('.pyv-card').forEach(function (el) { el.remove(); });

      var current = getCurrent();
      if (!current) {
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;

      var buildOpts = getBuildOpts();

      var behindCount = 2;
      for (var b = behindCount; b >= 1; b--) {
        if (state.queue.length > b) {
          var behindProd = state.products[state.queue[b]];
          var behindCard = PYVCard.buildCard(behindProd, 'behind', buildOpts);
          behindCard.style.transition = 'none';
          applyStackPosition(behindCard, b);
          deck.appendChild(behindCard);
        }
      }

      var topCard = PYVCard.buildCard(current, 'top', buildOpts);

      if (isAfterTransition) {
        var offsets = getOffsets();
        var startTx = -(1 * offsets.x);
        var startTy = 1 * offsets.y;
        topCard.style.transition = 'none';
        topCard.style.transform = 'translate(' + startTx + 'px, ' + startTy + 'px)';
        deck.appendChild(topCard);
        void topCard.offsetHeight;
        topCard.style.transition = 'transform 380ms cubic-bezier(0.22, 0.82, 0.2, 1)';
        topCard.style.transform = 'translate(0px, 0px)';
        setTimeout(function () {
          if (topCard.parentNode) topCard.style.transition = 'none';
        }, 390);
      } else {
        topCard.style.transition = 'none';
        topCard.style.transform = 'translate(0px, 0px)';
        deck.appendChild(topCard);
      }

      PYVCard.attachDrag(topCard, swipeThreshold, {
        getAnimating: function () { return state.animating; },
        onMove: function (dx) { updateSideStates(dx); },
        onCommitAdd: function () { commitAction('add'); },
        onCommitPass: function () { commitAction('pass'); },
        onSnapBack: function () { resetAllUI(); }
      });

      if (IS_MOBILE) {
        var mobileInfoBar = topCard.querySelector('.pyv-mobile-info');
        if (mobileInfoBar) {
          attachMobileSizeGuide(mobileInfoBar);
          /* Stars already rendered synchronously by buildCard — nothing extra needed */
        }
      }

      if (!state.statusLocked) updateCurrentlyViewing(current);
      renderUpNext();
      updatePagination();
    }

    /* ====================================================
       commitAction()
    ==================================================== */
    var FLY_DURATION = 420;

    function commitAction(action) {
      if (state.animating) return;
      state.animating = true;
      clearTimeout(statusFadeTimer);

      var current = getCurrent();
      if (!current) { state.animating = false; return; }

      var topCard = deck.querySelector('.pyv-card-top');
      if (!topCard) { state.animating = false; return; }

      var dir = (action === 'add') ? 1 : -1;

      topCard.style.transition = '';
      void topCard.offsetHeight;
      topCard.classList.add('is-flying');
      topCard.style.transform = 'translate(' + (dir * (window.innerWidth || 1200)) + 'px, 0px) rotate(' + (dir * 28) + 'deg)';

      var offsets = getOffsets();
      var behindCards = Array.prototype.slice.call(deck.querySelectorAll('.pyv-card-behind'));
      behindCards.forEach(function (bc, i) {
        var targetIndex = i;
        var tx = -(targetIndex * offsets.x);
        var ty = targetIndex * offsets.y;
        bc.style.transition = '';
        void bc.offsetHeight;
        bc.style.transition = 'transform ' + FLY_DURATION + 'ms cubic-bezier(0.22, 0.82, 0.2, 1)';
        void bc.offsetHeight;
        bc.style.transform = 'translate(' + tx + 'px, ' + ty + 'px)';
      });

      renderUpNextFromList(getUpNextFromOffset(2));

      state.statusLocked = true;
      if (!IS_MOBILE) showActionState((action === 'add') ? 'added' : 'passed', current);
      if (instrAddEl) instrAddEl.classList.remove('is-active');
      if (instrPassEl) instrPassEl.classList.remove('is-active');
      if (addBtn) addBtn.classList.remove('is-priming');
      if (passBtn) passBtn.classList.remove('is-priming');
      if (upNextEl) upNextEl.dataset.state = 'idle';

      statusFadeTimer = setTimeout(function () {
        if (action === 'add') {
          var sv = getSelectedVariant(current);
          if (sv && sv.id && sv.available) addToCart(sv.id);
        }

        state.queue.push(state.queue.shift());
        state.animating = false;
        render(true);

        statusFadeTimer = setTimeout(function () {
          if (!statusEl) return;
          var s = statusEl.dataset.state;
          if (s !== 'added' && s !== 'passed') return;
          statusEl.classList.add('is-fading-out');
          statusFadeTimer = setTimeout(function () {
            state.statusLocked = false;
            if (!statusEl) return;
            var s2 = statusEl.dataset.state;
            if (s2 !== 'added' && s2 !== 'passed') return;
            var np = getCurrent();
            if (np) updateCurrentlyViewing(np);
            else { statusEl.classList.remove('is-fading-out'); statusEl.dataset.state = 'viewing'; }
          }, 380);
        }, 1500);
      }, FLY_DURATION);
    }

    /* ====================================================
       triggerAction()
    ==================================================== */
    function triggerAction(action) {
      if (state.animating) return;
      var card = deck.querySelector('.pyv-card-top');
      if (!card) return;
      state.animating = true;
      clearTimeout(statusFadeTimer);

      var dir = (action === 'add') ? 1 : -1;
      var cardW = card.offsetWidth || 340;
      var targetX = dir * cardW * 0.60;
      var sweepDuration = 350;
      var t0 = performance.now();

      function step(now) {
        var elapsed = now - t0;
        var t = Math.min(elapsed / sweepDuration, 1);
        var ease = 1 - Math.pow(1 - t, 3);
        var x = targetX * ease;
        PYVCard.applyTransform(card, x, 0);
        PYVCard.updateOverlays(card, x, swipeThreshold);
        updateSideStates(x);
        if (t < 1) {
          requestAnimationFrame(step);
        } else {
          state.animating = false;
          commitAction(action);
        }
      }
      requestAnimationFrame(step);
    }

    /* ---- Cycle (arrows) ---- */
    function cycleQueue(direction) {
      if (state.animating) return;
      if (state.queue.length < 2) return;
      state.animating = true;
      clearTimeout(statusFadeTimer);
      state.statusLocked = false;

      var topCard = deck.querySelector('.pyv-card-top');
      if (!topCard) { state.animating = false; return; }

      var dir = (direction > 0) ? 1 : -1;
      topCard.style.transition = '';
      void topCard.offsetHeight;
      topCard.classList.add('is-snapping');
      topCard.style.transform = 'translate(' + (dir * 50) + 'px, 0) rotate(' + (dir * 4) + 'deg)';
      topCard.style.opacity = '0';

      setTimeout(function () {
        if (direction > 0) state.queue.push(state.queue.shift());
        else state.queue.unshift(state.queue.pop());
        state.animating = false;
        render(false);
      }, 200);
    }

    /* ---- Cart ---- */
    function addToCart(variantId) {
      var sections = ['cart-notification', 'cart-drawer', 'cart-icon-bubble', 'cart-live-region-text', 'cart-items']
        .filter(function (id) { return document.getElementById(id) || document.querySelector(id); });
      var body = { items: [{ id: variantId, quantity: 1 }] };
      if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          updateCartCount(true);
          if (autoOpenCart) { dispatchCartEvents(data); }
          else { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data, bubbles: true })); }
        })
        .catch(function (e) { console.error('PYV: add to cart failed', e); });
    }

    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        if (typeof drawer.open === 'function') { drawer.open(); return; }
        drawer.removeAttribute('hidden'); drawer.setAttribute('open', ''); return;
      }
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      var nativeBtn = document.querySelector('[data-cart-icon-bubble], .site-header__cart, .header__icon--cart, a[href="/cart"]:not([data-pyv-cart-badge]):not(.pyv-cart-badge)');
      if (nativeBtn) nativeBtn.click();
    }

    function dispatchCartEvents(data) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data, bubbles: true }));
      openCartDrawer();
      var notif = document.querySelector('cart-notification');
      if (notif && typeof notif.open === 'function') notif.open();
    }

    function updateCartCount(bump) {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cartCountEl) return;
          cartCountEl.textContent = cart.item_count;
          cartCountEl.classList.toggle('has-items', cart.item_count > 0);
          if (bump) {
            cartCountEl.classList.add('is-bumping');
            setTimeout(function () { cartCountEl.classList.remove('is-bumping'); }, 300);
          }
        })
        .catch(function () {});
    }

    if (cartBadgeEl) {
      cartBadgeEl.addEventListener('click', openCartDrawer);
      cartBadgeEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openCartDrawer(); }
      });
    }

    var cartSyncTimer = null;
    function debouncedCartSync() {
      clearTimeout(cartSyncTimer);
      cartSyncTimer = setTimeout(function () { updateCartCount(false); }, 300);
    }

    ['cart:refresh', 'cart:update', 'cart:updated', 'cart:change', 'variant:added'].forEach(function (evt) {
      document.addEventListener(evt, debouncedCartSync);
    });

    function observeCartDrawer() {
      var sels = ['cart-drawer', 'cart-notification', '#CartDrawer', '.cart-drawer'];
      var el = null;
      for (var i = 0; i < sels.length; i++) { el = document.querySelector(sels[i]); if (el) break; }
      if (el) { new MutationObserver(debouncedCartSync).observe(el, { childList: true, subtree: true, characterData: true }); }
      else { setTimeout(observeCartDrawer, 1500); }
    }
    observeCartDrawer();

    if (passBtn) passBtn.addEventListener('click', function () { triggerAction('pass'); });
    if (addBtn) addBtn.addEventListener('click', function () { triggerAction('add'); });
    if (prevBtn) prevBtn.addEventListener('click', function () { if (arrowsAsActions) triggerAction('pass'); else cycleQueue(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { if (arrowsAsActions) triggerAction('add'); else cycleQueue(1); });

    initPagination();
    render(false);
    updateCartCount(false);
  }

})();